var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 3.77273C7.34427 3.77273 3.77273 7.34427 3.77273 11.75C3.77273 16.1557 7.34427 19.7273 11.75 19.7273C16.1557 19.7273 19.7273 16.1557 19.7273 11.75C19.7273 7.34427 16.1557 3.77273 11.75 3.77273ZM2 11.75C2 6.36523 6.36522 2 11.75 2C17.1348 2 21.5 6.36523 21.5 11.75C21.5 17.1348 17.1348 21.5 11.75 21.5C6.36522 21.5 2 17.1348 2 11.75ZM15.1623 8.33767C15.5085 8.68382 15.5085 9.24503 15.1623 9.59118L13.0035 11.75L15.1623 13.9088C15.5085 14.255 15.5085 14.8162 15.1623 15.1623C14.8162 15.5085 14.255 15.5085 13.9088 15.1623L11.75 13.0035L9.59119 15.1623C9.24504 15.5085 8.68383 15.5085 8.33768 15.1623C7.99153 14.8162 7.99153 14.255 8.33768 13.9088L10.4965 11.75L8.33768 9.59118C7.99153 9.24503 7.99153 8.68382 8.33768 8.33767C8.68383 7.99152 9.24504 7.99152 9.59119 8.33767L11.75 10.4965L13.9088 8.33767C14.255 7.99153 14.8162 7.99153 15.1623 8.33767Z",
    fill: "#FF4949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedLogo);
export default __webpack_public_path__ + "static/media/failed-logo.9683c5cdeeedfd4c76ad68b211a99fac.svg";
export { ForwardRef as ReactComponent };